import React from 'react';
import { useForm } from 'react-hook-form';
import SpinnerButton from '../Common/SpinnerButton';
import { EmailSettingsDto } from '../Requests/EmailSettings/useGetEmailSettings';
import { EmailConfigurationUpdate } from '../Requests/EmailSettings/useUpdateEmailSettings';

interface EmailConfigurationFormProps {
  settings: EmailSettingsDto;
  onSave: (formData: EmailConfigurationUpdate) => void;
  isLoading: boolean;
}

const EmailConfigurationForm: React.FC<EmailConfigurationFormProps> = ({
  settings,
  onSave,
  isLoading
}) => {
  const { register, handleSubmit, watch } = useForm<EmailConfigurationUpdate>({
    defaultValues: {
      isEnabled: settings.isEnabled,
      sendToCustomers: settings.sendToCustomers,
      sendToBranches: settings.sendToBranches,
      sendToDrivers: settings.sendToDrivers,
      sendToCarriers: settings.sendToCarriers,
      sendToApplicators: settings.sendToApplicators,
    }
  });

  const isEnabledValue = watch('isEnabled');

  const handleSave = (formValues: EmailConfigurationUpdate) => onSave(formValues);

  return (
    <>
      <div className="row m-2 p-3 mb-4">
        <div className="col-12 mb-3">
          <h4 className="mb-0">Email Configuration</h4>
        </div>
        <div className="col-12 mb-2">
          <div className="row">
            <div className="col-11">
              <label className="text-dark fw-semibold" htmlFor="emailEnabled">
                Enable Ticket Confirmation Emails
              </label>
              <p><small>Toggle to enable or disable email notifications</small></p>
            </div>
            <div className="col-1 text-end form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                id="emailEnabled"
                {...register('isEnabled')}
              />
            </div>
          </div>
        </div>
        <div className="col-12">
          <h5 className="mb-2">Select Email Recipients</h5>
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="sendToCustomers"
              disabled={!isEnabledValue}
              {...register('sendToCustomers')}
            />
            <label className="form-check-label" htmlFor="sendToCustomers">
              Customers
            </label>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="sendToBranches"
              disabled={!isEnabledValue}
              {...register('sendToBranches')}
            />
            <label className="form-check-label" htmlFor="sendToBranches">
              Branches
            </label>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="sendToDrivers"
              disabled={!isEnabledValue}
              {...register('sendToDrivers')}
            />
            <label className="form-check-label" htmlFor="sendToDrivers">
              Drivers
            </label>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="sendToCarriers"
              disabled={!isEnabledValue}
              {...register('sendToCarriers')}
            />
            <label className="form-check-label" htmlFor="sendToCarriers">
              Carriers
            </label>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="sendToApplicators"
              disabled={!isEnabledValue}
              {...register('sendToApplicators')}
            />
            <label className="form-check-label" htmlFor="sendToApplicators">
              Applicators
            </label>
          </div>
        </div>
      </div>
      <div className="text-end">
        <SpinnerButton
          className="btn-ghost-primary"
          spinning={isLoading}
          onClick={handleSubmit(handleSave)}>
          Save
        </SpinnerButton>
      </div>
    </>
  );
};

export default EmailConfigurationForm;